<template>
    <div class="tw-flex-grow tw-bg-gray-800 tw-text-gray-300 tw-p-4 tw-h-full tw-overflow-y-auto">
        <h2 class="tw-text-xl tw-font-bold tw-mb-4">Entity List</h2>
        <div v-if="clientExplorerStore.isLoading" class="tw-text-center tw-py-4">
            Loading...
        </div>
        <div v-else-if="clientExplorerStore.results?.length > 0" class="tw-overflow-x-auto">
            <table class="tw-min-w-full tw-divide-y tw-divide-gray-700">
                <thead class="tw-bg-gray-700">
                    <tr>
                        <th class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-300 tw-uppercase tw-tracking-wider">ID</th>
                        <th class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-300 tw-uppercase tw-tracking-wider">Entity Type</th>
                        <th class="tw-px-6 tw-py-3 tw-text-left tw-text-xs tw-font-medium tw-text-gray-300 tw-uppercase tw-tracking-wider">Description</th>
                    </tr>
                </thead>
                <tbody class="tw-bg-gray-800 tw-divide-y tw-divide-gray-700">
                    <tr 
                        v-for="row in clientExplorerStore.results" 
                        :key="row.id" 
                        @mouseenter="clientExplorerStore.selectEntity(row.id)"
                        @mouseleave="clientExplorerStore.deselectEntity()"
                        class="tw-hover:bg-gray-700 tw-cursor-pointer">
                        <td class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-300">{{ row.id }}</td>
                        <td class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-300">{{ row.entity_type }}</td>
                        <td class="tw-px-6 tw-py-4 tw-whitespace-nowrap tw-text-sm tw-text-gray-300">{{ row.description }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="tw-p-4 tw-text-center tw-text-gray-400">
            No results found. Please select a category from the sidebar.
            <br>
            Debug info:
            <pre>{{ JSON.stringify(clientExplorerStore, null, 2) }}</pre>
        </div>
    </div>
</template>

<script>
export default {
    name: 'client-explorer-list',
    inject: ['getClientExplorerStore'],
    computed: {
        clientExplorerStore() {
            return this.getClientExplorerStore();
        }
    },
    mounted() {
        console.log('ClientExplorerList mounted');
        console.log('clientExplorerStore:', this.clientExplorerStore);
        console.log('results:', this.clientExplorerStore.results);
    }
};
</script>

<style scoped>
    .entity-explorer-list-view {
        height: 100%;
        background-color: #1f1f1f;
        color: #e0e0e0;
    }

    :deep(.o-table) {
        background-color: transparent;
        color: #e0e0e0;
    }

    :deep(.o-table th) {
        background-color: #252525;
        color: #bbb;
        font-weight: 600;
        border-bottom: 1px solid #333;
    }

    :deep(.o-table td) {
        border-bottom: 1px solid #333;
    }

    :deep(.o-table-row:hover) {
        background-color: #2a2a2a;
    }

    :deep(.o-pagination) {
        background-color: #252525;
        color: #e0e0e0;
    }

    :deep(.o-pagination-link) {
        color: #4a9eff;
    }

    :deep(.o-pagination-link.is-current) {
        background-color: #4a9eff;
        border-color: #4a9eff;
        color: #fff;
    }
</style>
